(function(){
    angular.module('tmx-app').factory('BulkUploadService', ['$mdMedia','tmxResource',
        function($mdMedia,tmxResource){

            var BulkUpload = tmxResource("Organization");
            //BulkUpload.getOrganizations = getOrganizations;
            var menulinkHtml = "";
            menulinkHtml = menulinkHtml + "<md-menu flex='none' ng-if='BukUploadCtrl.showBulkAssignment'  class='menu-list-item' md-offset='-60 60'> ";
            menulinkHtml = menulinkHtml + "    <md-button style='right:-5px !important;'  class='menu-list-item-grid' ng-click='$mdOpenMenu()' > ";
            menulinkHtml = menulinkHtml + "        <md-icon class='menu-list-item material-icons margin-right-24'>more_vert</md-icon> ";
            menulinkHtml = menulinkHtml + "    </md-button> ";
            menulinkHtml = menulinkHtml + "    <md-menu-content width='2'> ";
            menulinkHtml = menulinkHtml + "        <md-menu-item> ";
            menulinkHtml = menulinkHtml + "            <md-button  aria-label='del' class='tmxMin' ng-click='BukUploadCtrl.applicationReassign()'> ";
            menulinkHtml = menulinkHtml + "                 <md-icon class='md-accent material-icons menu-list-item'>check</md-icon> {{\"Reassign\"|translate}}";
            menulinkHtml = menulinkHtml + "            </md-button> ";
            menulinkHtml = menulinkHtml + "        </md-menu-item> ";
            menulinkHtml = menulinkHtml + "    </md-menu-content> ";
            menulinkHtml = menulinkHtml + "</md-menu>";


//  <md-checkbox style='top: 10px;left:10px;' ng-change='BukUploadCtrl.allApplicationChecked(check)' ng-model='check' />
            BulkUpload.gridColumn = [
                {   
                    width: $mdMedia('gt-sm') ? '6%' : '150px',
                    headerTemplate:"",
                    template: "<md-checkbox style='top: 10px;' ng-change='BukUploadCtrl.applicationChecked(dataItem)' ng-model='dataItem.Selected' />"
                },
                {
                    field:"ApplicationNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('ApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"ApplicationNumber\")' ></i></span>"

                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "alpha",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "{{dataItem.CustomerName}}"
                },
                {
                    field:"ProductName",
                    title:"ProductName",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName | cut:true:6 }}</span><md-tooltip md-direction='top'>{{dataItem.ProductName}}</md-tooltip>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('ProductName')}\" >{{'ProductName' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"BranchName",
                    title:"BranchName ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"InboxUser",
                    title:"InboxUser",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"InboxUser\")' ></i></span>"
                },
                {
                    field:"Creator",
                    title:"Creator",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"Creator\")' ></i></span>"
                },
                {
                    field:"ApplicationDate",
                    title:"ApplicationDate",
                    type: "date",
                    search: true,
                    template: "<span ><md-tooltip md-direction='top'>{{BukUploadCtrl.formatDate(dataItem)}}</md-tooltip> {{BukUploadCtrl.formatDate(dataItem)}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('ApplicationDate')}\" >{{'ApplicationDate' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"ApplicationDate\")' ></i></span>"
                },
                {
                    field:"CurrentState",
                    title:"CurrentState",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('CurrentState')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"CurrentState\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : BukUploadCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='BukUploadCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
                },
                {
                    width: $mdMedia('gt-sm') ? '10%' : '150px',
                    template: "<md-menu flex='none' class='menu-list-item'><md-button ng-click='$mdOpenMenu()'><md-icon class='menu-list-item material-icons  margin-right-24'>more_vert</md-icon></md-button><md-menu-content width='2'><md-menu-item>"+
        "<md-button  aria-label='del' class='tmxMin' ng-click='BukUploadCtrl.applicationReassign()'> "+
        "<md-icon class='md-accent material-icons menu-list-item'>check</md-icon> {{\"Reassign\"|translate}}"+
        "</md-button> "+
        "</md-menu-item></md-menu-content></md-menu>",
                    headerTemplate: menulinkHtml,
                }

            ];
 

            BulkUpload.columns = angular.copy(BulkUpload.gridColumn);
            BulkUpload.UploadData=function(file,transactiontype,organizationid){
                return tmxResource("BulkUpload").getByAction("BulkUpload/"+transactiontype + "/" +organizationid  ,false,"post",file);
            }
            BulkUpload.getOrganizations = function () {
                return tmxResource("Organization").all();
            };
            return BulkUpload;

        }]);
})();